module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone"
  }, [_c('iframe', {
    staticClass: "demo-page",
    attrs: {
      "src": '//elemefe.github.io/mint-ui/#' + (_vm.routePath === '/loadmore' ? '/pull-down' : (_vm.routePath === '/repositories' || _vm.routePath === '/quickstart' ? '' : _vm.routePath)),
      "frameborder": "0"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e24ef92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/phone.vue
// module id = 64
// module chunks = 128